var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0